import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amountRenderer',
})
@Injectable({
  providedIn: 'root',
})
export class AmountRendererPipe implements PipeTransform {
  private readonly locale: string = 'en-US';
  private readonly options: Intl.NumberFormatOptions = {
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'currency',
  };

  transform(value?: number): string {
    if (!value) {
      return '';
    }
    return value.toLocaleString(this.locale, this.options);
  }
}
